import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import {
  FaTachometerAlt,
  FaBoxes,
  FaShoppingCart,
  FaShoppingBasket,
  FaCalculator,
  FaCog,
  FaUserCircle,
  FaSignOutAlt,
  FaSave
} from 'react-icons/fa';
import { authActions } from '../../sagas/authSlice';
import './ModuleSelector.css';

const ModuleSelector = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { fullName, businessName } = useSelector(state => state.auth);

  const modules = [
    { id: 'dashboard', title: t('modules.dashboard.title'), icon: FaTachometerAlt, color: '#0d6efd', route: '/dashboard' },
    { id: 'inventory', title: t('modules.inventory.title'), icon: FaBoxes, color: '#198754', route: '/inventory-module' },
    { id: 'pos', title: 'Point de Vente', icon: FaShoppingCart, color: '#d63384', route: '/comptoire' },
    { id: 'sales', title: t('modules.sales.title'), icon: FaShoppingCart, color: '#0dcaf0', route: '/sales-module' },
    { id: 'purchases', title: t('modules.purchases.title'), icon: FaShoppingBasket, color: '#fd7e14', route: '/purchases-module' },
    { id: 'accounting', title: t('modules.accounting.title'), icon: FaCalculator, color: '#6610f2', route: '/accounting-module' },
    { id: 'backups', title: t('modules.backups.title'), icon: FaSave, color: '#115c9eff', route: '/backups-module' },
    { id: 'settings', title: t('modules.settings.title'), icon: FaCog, color: '#6c757d', route: '/settings-module' },
  ];

  const handleLogout = () => {
    Swal.fire({
      title: 'Confirmer la déconnexion',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Se déconnecter',
      cancelButtonText: 'Annuler'
    }).then((r) => {
      if (r.isConfirmed) {
        dispatch(authActions.logout());
        localStorage.clear();
        navigate('/login');
      }
    });
  };

  return (
    <div className="module-selector-wrapper">

      {/* HERO */}
      <div className="hero-section">
        <Container className="hero-content-centered">
          <h2 className="hero-title">
            {t('modules.welcome', { businessName })}
          </h2>

          <div className="hero-right">
            <div className="user-pill">
              <FaUserCircle size={16} />
              <span>{fullName}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <FaSignOutAlt size={14} />
              <span>Déconnexion</span>
            </button>
          </div>
        </Container>
      </div>

      {/* MODULES – ONE ROW */}
      <Container className="modules-container">
        <div className="modules-row">
          {modules.map((module) => (
            <Card
              key={module.id}
              className="module-card-dense"
              onClick={() => navigate(module.route)}
            >
              <CardBody className="module-card-body-dense">
                <div
                  className="module-icon-dense"
                  style={{ color: module.color }}
                >
                  <module.icon size={28} />
                </div>
                <div className="module-title-dense">
                  {module.title}
                </div>
              </CardBody>
            </Card>
          ))}
        </div>
      </Container>

      {/* FOOTER */}
      <footer className="app-footer">
        <Container className="footer-content">
          <span><strong>{businessName}</strong> — ERP & POS</span>
          <span>© {new Date().getFullYear()} {businessName}</span>
          <span>Powered by <strong>IDERACLOUD</strong></span>
        </Container>
      </footer>

    </div>
  );
};

export default ModuleSelector;
